import * as React from "react";

function Eye(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.021 7.913c-1.21.87-2.196 1.936-2.819 2.693a.605.605 0 000 .788c.623.757 1.61 1.823 2.819 2.693 1.216.875 2.58 1.496 3.98 1.496 1.398 0 2.762-.621 3.978-1.496 1.21-.87 2.196-1.936 2.82-2.693a.605.605 0 000-.788c-.624-.757-1.61-1.823-2.82-2.693C13.763 7.037 12.4 6.416 11 6.416s-2.763.621-3.979 1.497zM5.95 6.424c1.377-.99 3.115-1.841 5.05-1.841 1.933 0 3.671.85 5.049 1.841 1.385.997 2.485 2.193 3.163 3.016a2.438 2.438 0 010 3.12c-.678.823-1.778 2.018-3.163 3.015-1.378.991-3.116 1.841-5.05 1.841-1.934 0-3.672-.85-5.05-1.841-1.385-.997-2.485-2.192-3.163-3.016a2.438 2.438 0 010-3.119c.678-.823 1.778-2.02 3.163-3.016z"
        fill={props.color||"var(--color-neutral-500)"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9.166a1.833 1.833 0 100 3.667 1.833 1.833 0 000-3.667zM7.333 11a3.667 3.667 0 117.334 0 3.667 3.667 0 01-7.333 0z"
        fill={props.color||"var(--color-neutral-500)"}
      />
    </svg>
  );
}

export default Eye;
